export const management = {
  routes: [
    {
      path: "/management/config",
      component: () => import("../management-config-parameter-view"),
    },
  ],
};
